import { Card, Flex } from "antd";
import { Line, type LineConfig } from "@ant-design/plots";
import { dashboardQueryFactory } from "@/console/apis/dashboard/queryFactory";
import dayjs from "dayjs";
import { memberQueryFactory } from "@/console/apis/member/queryFactory";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

const Attendance = () => {
  const { t } = useTranslation();
  const today = dayjs();
  const monthAgo = today.subtract(1, "month");

  const { data = [] } = dashboardQueryFactory.getAttendanceStatistics({
    from: monthAgo.format("YYYY-MM-DD"),
    to: today.format("YYYY-MM-DD"),
  });
  const { data: memberCount } = useQuery(memberQueryFactory.getMemberCount());
  const config: LineConfig = {
    data,
    xField: "date",
    yField: "count",
    yAxis: {
      max: memberCount,
      tickInterval: 1,
    },
    point: {
      size: 5,
      shape: "circle",
    },
    label: {
      position: "top",
    },
    meta: {
      date: {
        alias: t("dashboard.Date"),
      },
      count: {
        alias: t("dashboard.Attendance"),
      },
    },
    key: (record: { date: string }) => `attendance-${record.date}`,
  };

  return (
    <Flex className="w-full mt-4">
      <Card
        title={t("dashboard.todaysAttendance")}
        className="w-full p-2"
        styles={{
          body: {
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
        }}
      >
        <Flex vertical className="items-center">
          <span className="text-2xl font-semibold">
            {
              data.filter(
                (item: { date: string }) =>
                  item.date === today.format("YYYY-MM-DD")
              ).length
            }
          </span>
          <span className="text-sm text-gray-500">
            {t("dashboard.Members")}
          </span>
        </Flex>
      </Card>
      <Card
        title={t("dashboard.Attendance")}
        className="flex flex-row justify-between w-full p-2"
        styles={{
          body: {
            padding: "0px 24px 24px 24px",
          },
        }}
      >
        <Line {...config} key={`attendance-chart-${data.length}`} />
      </Card>
    </Flex>
  );
};

export default Attendance;
